import { createContext } from "react";

export const AppContext = createContext({
	trans: null,
	appConfig: null,
	cLang: 'en-US',
	dLang: 'en-US'
})